import { useApi } from './api';

export const useStandings = (season, type = 'total') => {
  const api = useApi(`statistics/standings/${season}/${type}`);
  const [data, loading, error] = api;

  return [
    Object.values(data || {}).map((item) => ({
      ...item,
      teamAbbrv: item.teamAbbrv || item.abbrv,
      teamDisplayName: item.teamDisplayName || item.name,
    })),
    loading,
    error,
  ];
};
